import ToggleButton from './component';

export default ToggleButton;
